import Cookies from 'js-cookie';
import { createSelector } from 'reselect';

import { PLATFORM_COOKIES } from '@/features/cookies/platform-cookies';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { Platform } from '@/features/game-context/types';
import { geolocationSelector } from '@/features/geolocation/store/geolocation';
import { GeolocationProgress } from '@/features/geolocation/types';

export const ipAddressSelector = createSelector(
  gameContextSelector,
  geolocationSelector,
  (context, geolocation) => {
    if (
      context.platform === Platform.iOS ||
      context.platform === Platform.Xsell
    ) {
      return Cookies.get(PLATFORM_COOKIES.IP_ADDRESS) ?? '10.123.0.55';
    }

    if (
      geolocation.progress === GeolocationProgress.Success &&
      geolocation.jwt
    ) {
      try {
        const parsed = JSON.parse(atob(geolocation.jwt.split('.')[1]));

        if ('ip_address' in parsed) {
          return parsed.ip_address;
        }
      } catch {
        return undefined;
      }
    }

    return undefined;
  },
);
